import { render } from "./MfTable.vue?vue&type=template&id=4b32b114"
import script from "./MfTable.vue?vue&type=script&lang=js"
export * from "./MfTable.vue?vue&type=script&lang=js"

import "./MfTable.vue?vue&type=style&index=0&id=4b32b114&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__